<template>
  <div
    id="AppMainContainer"
    class="transition h-full px-16 pb-24 d-block overflow-auto"
    :class="{ 'bg-gray-2': isAuthBg }"
  >
    <HeaderComponent v-if="isLoaded && !isSSORoute" :is-auth="isAuthBg" />

    <router-view v-if="isLoaded" />

    <ToastList
      v-if="notifications.length"
      :notifications-arr="notifications"
      @close-toast="notificationsStore.removeNotification"
    />
    <ModalRendererComponent :modals="modals" @close="modalStore.closeModal" />
  </div>
</template>

<script setup>
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import { useAuthStore } from '@/stores/authStore'
import { useNotificationsStore } from '@/stores/notificationsStore'
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { ToastList } from '@snowshoe-frontend/toast-component'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useLanguages } from '@/composables/useLanguages'
import { ModalRendererComponent } from '@snowshoe-frontend/modal-component'
import { useModalStore } from '@/stores/modalStore'

const SSO_VIEW_NAME = 'SsoView'

const route = useRoute()
const i18n = useI18n()

const authStore = useAuthStore()
const notificationsStore = useNotificationsStore()
const modalStore = useModalStore()

const { isAuth } = storeToRefs(authStore)
const { notifications } = storeToRefs(notificationsStore)
const { modals } = storeToRefs(modalStore)
const { changeLanguage } = useLanguages()

const isLoaded = ref(false)

const isSSORoute = computed(() => {
  return route.name === SSO_VIEW_NAME
})
const isAuthBg = computed(() => isAuth.value && route.name !== 'Login')

onMounted(async () => {
  try {
    await changeLanguage(i18n.locale.value)
  } finally {
    isLoaded.value = true
  }
})
</script>
